import Immutable from "immutable";

const windowDefaults = Object.freeze({
  isVisible: false,
  title: "",
  content: "",
  image: "",
  type: null,
  clients: [],
  actionRequired: false
});

const windowAlertMap = Immutable.Map(windowDefaults);

export const windowAlert = (state = windowAlertMap, action) => {
  switch (action.type) {
    case "GENERATE_WINDOW_ALERT": {
      /*
            Check if the clients list on the event is non-empty
            which indicates we need to only show this alert to the
            included clients
            */
      const allowed = action.clients;
      /** @type Client */
      const client = action.currentClient;

      if (allowed.length > 0) {
        if (!allowed.includes(client.handle) && !allowed.includes(client.id)) {
          return state;
        }
      }

      return state.merge({
        isVisible: true,
        title: action.title,
        content: action.content,
        image: action.image,
        actionRequired: action.actionRequired,
        type: action.windowAlertType || "basic"
      });
    }

    case "DISMISS_WINDOW_ALERT":
      return state.merge({ isVisible: false });
    default:
      return state;
  }
};
